<template>
  <b-card>
    <div
      slot="header"
      class="d-flex justify-content-between"
    >
      <div
        class="d-flex"
        @click="onRuleNameClick"
      >
        <b-form-input
          v-if="isEditable"
          :id="`rule-${ruleItemIndex}-name`"
          v-model="model.RuleName"
          size="sm"
          autofocus
          class="rule-input-editor"
          @blur="finishEdit"
          @keydown.enter="finishEdit"
          @keydown.esc="finishEdit"
        />
        <span
          v-else
          :id="`rule-${ruleItemIndex}-displayName`"
          class="panel-header rule-name"
        >
          {{ getRuleName() }}
        </span>
        <span
          v-if="!isEditable"
          class="text-danger"
        >&nbsp;*</span>
      </div>
      <b-button
        :id="`rule-${ruleItemIndex}-delete`"
        size="sm"
        variant="outline-danger"
        @click="onDeleteRuleClick"
      >
        <font-awesome-icon :icon="['fas', 'trash']" />
        Delete Rule
      </b-button>
    </div>
    <div class="d-flex justify-content-between">
      <h4 class="pt-2 pb-3">
        Validation Criteria
      </h4>
      <p class="alert alert-danger">
        The record must pass the validation criteria below:
      </p>
    </div>
    <main-condition
      :model="model.LogicTree"
      :fields="fields"
      :table-fields="tableFields"
      :rule-index="index + 1"
    />
    <h4 class="pt-3 pb-3">
      Validation Message
    </h4>
    <div class="row">
      <div class="col-sm-4">
        <input-widget
          :id="`rule-${ruleItemIndex}-type`"
          :model="model"
          :field="fields.ValidationRuleType"
        />
      </div>
      <div class="col-sm-8">
        <input-widget
          :id="`rule-${ruleItemIndex}-description`"
          :model="model"
          :field="fields.RuleDescription"
        />
      </div>
    </div>
  </b-card>
</template>

<script>
import InputWidget from '../../../../../core/components/complex-table/components/InputWidget';
import ConditionItem from './ConditionItem';
import MainCondition from './MainCondition';
import {truncate} from 'lodash/string';

export default {
  name: 'RuleItem',
  components: {MainCondition, ConditionItem, InputWidget},
  props: {
    model: Object,
    fields: Object,
    index: Number,
    rule: Object,
    tableFields: Array,
  },
  data() {
    return {
      isEditable: false,
      oldName: '',
    };
  },
  computed: {
    ruleItemIndex() {
      return this.index + 1;
    },
  },
  methods: {
    onDeleteRuleClick() {
      this.$emit('on-delete-rule-click', this.index);
    },
    onRuleNameClick() {
      this.isEditable = true;
      this.oldName = this.model.RuleName;
    },
    finishEdit(e) {
      if (e.key === 'Escape' || e.target.value === '') {
        this.model.RuleName = this.oldName;
      }
      this.isEditable = false;
    },
    getRuleName() {
      return truncate(this.rule.RuleName, {
        length: 50,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.rule-input-editor {
  width: 250px;
}

.rule-name {
  color: #428bca;
  border-bottom: 1px dashed;
  cursor: pointer;
}
</style>